import React, { useState, createContext, useContext } from 'react';
import { AnimatePresence } from 'framer-motion';
import { HomePage } from './pages/HomePage';
import { MessagesPage } from './pages/MessagesPage';
import { MapsPage } from './pages/MapsPage';
import { SettingsPage } from './pages/SettingsPage';
import { BottomNav } from './components/BottomNav';
import { useDarkMode } from './hooks/useDarkMode';
// Dark mode context
const DarkModeContext = createContext<{
  isDark: boolean;
  toggle: () => void;
}>({
  isDark: false,
  toggle: () => {}
});
export const useDarkModeContext = () => useContext(DarkModeContext);
export function App() {
  const [activeTab, setActiveTab] = useState('home');
  const darkMode = useDarkMode();
  // Handle navigation
  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <HomePage key="home" data-id="element-0" />;
      case 'explore':
        return <MessagesPage key="explore" data-id="element-1" />;
      case 'maps':
        return <MapsPage key="maps" data-id="element-2" />;
      case 'settings':
        return <SettingsPage key="settings" data-id="element-3" />;
      default:
        return <HomePage key="home" data-id="element-4" />;
    }
  };
  return <DarkModeContext.Provider value={darkMode} data-id="element-5">
      <div className="min-h-screen bg-gray-100 dark:bg-gray-950 flex justify-center transition-colors duration-300" data-id="element-6">
        <div className="w-full max-w-md bg-white dark:bg-gray-900 min-h-screen shadow-2xl relative overflow-hidden" data-id="element-7">
          <AnimatePresence mode="wait" data-id="element-8">{renderContent()}</AnimatePresence>
          <BottomNav activeTab={activeTab} onTabChange={setActiveTab} data-id="element-9" />
        </div>
      </div>
    </DarkModeContext.Provider>;
}